import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { titleAPI } from '../../utilities/api';
import { Title } from '../../utilities/interfaces/Title';

// represents the shape of the slice in state
interface TitleState {
  value: any;
  titleList: any;
  selectedTitle: any;
  filteredTitleList: any;
}

const initialState: TitleState = {
  value: [],
  titleList: [],
  selectedTitle: {},
  filteredTitleList: []
};

const titleSlice = createSlice({
  name: 'stateTitle',
  initialState,
  reducers: {
    // add new Title item
    addTitleItem(state, action: PayloadAction<Title>) {
      // its okay to do this because immer makes it immutable
      state.value.push(action.payload);
    },
    clearTitleItems(state) {
      state.titleList = [];
    },
    clearTitle(state) {
      state.selectedTitle = null;
    },
  },
  extraReducers(builder) {
    builder.addCase(getAllTitles.fulfilled, (state, action: any) => {
      for (var i = 0; i < action.payload.length; i++) {
        if (action.payload[i].titleName == null) {
          action.payload[i].titleName = '';
        }
      }
      state.value = action.payload;
    });
    builder.addCase(getTitleByAgencyId.fulfilled, (state, action: any) => {
      for (var i = 0; i < action.payload.length; i++) {
        if (action.payload[i].titleName == null) {
          action.payload[i].titleName = '';
        }
      }
      state.titleList = action.payload;
    });
    // this one needs to be fixed
    builder.addCase(updateTitle.fulfilled, (state, action: any) => {
      for (var i = 0; i < action.payload.length; i++) {
        if (action.payload[i].titleName == null) {
          action.payload[i] = state.value;
        }
      }
    });
    builder.addCase(getTitleById.fulfilled, (state, action: any) => {
      state.selectedTitle = action.payload;
    });
    builder.addCase(getFilteredTitles.fulfilled, (state, action: any) => {
      for (var i = 0; i < action.payload.length; i++) {
        if (action.payload[i].titleName == null) {
          action.payload[i].titleName = '';
        }
      }

      state.filteredTitleList = action.payload;
    });
  },
});

// Async thunk to fetch data from api
// under extra reducers on fulfilled the redux store is updated
export const getAllTitles = createAsyncThunk('stateTitle/getTitlesItems', async () => {
  const response = await titleAPI.getTitles();
  return response;
});

export const getTitleByAgencyId = createAsyncThunk(
  'stateTitle/getTitlesByAgencyId',
  async (id: number) => {
    const response = await titleAPI.getTitleByAgencyId(id);
    return response;
  }
);

export const getTitleById = createAsyncThunk('stateTitle/getTitleByid', async (id: number) => {
  const response = await titleAPI.getTitleById(id);
  return response;
});

export const updateTitle = createAsyncThunk('stateTitle/updateTitle', async (title: Title) => {
  await titleAPI.updateTitle(title);
  return title;
});

export const getFilteredTitles = createAsyncThunk('stateTitle/getFilteredTitles', async (agencyId: number) => {
  const response = await titleAPI.getFiltered(agencyId);
  return response;
});

export const { addTitleItem, clearTitleItems, clearTitle } = titleSlice.actions;
export default titleSlice.reducer;
